import React from 'react';
import { Link } from 'react-router-dom';
import './BrandCard.css';
import { nameUrlUtils } from '../../../Utils/nameUrlUtils';

const BASE_URL = process.env.REACT_APP_BASE_IMG_URL;
const BrandCard = ({ brand }) => {
  return (
    <Link 
      to={`/brand/${nameUrlUtils.convertNameToUrl(brand.name)}`} 
      className="brand-card"
    >
      <div className='brand-image'>
         <img src={`${brand.imageUrl}`} alt={brand.name} />
      </div>
      <div className='brand-name'>
      <h3>{brand.name}</h3>
      </div>
    </Link>
  );
};

export default BrandCard;